import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widerruf',
  templateUrl: './widerruf.component.html',
  styleUrls: ['./widerruf.component.scss']
})
export class WiderrufComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
